import React from 'react';

interface CanvasGridBackgroundProps {
    className?: string;
}

/** Theme-aware dot grid used behind the Cytoscape canvas. */
export const CanvasGridBackground: React.FC<CanvasGridBackgroundProps> = ({ className }) => (
    <div
        className={`absolute inset-0 pointer-events-none ${className ?? ''}`}
        style={{
            backgroundColor: 'hsl(var(--canvas-bg))',
            backgroundImage: 'radial-gradient(circle, hsl(var(--canvas-grid-dot)) 1px, transparent 1px)',
            backgroundSize: 'var(--canvas-grid-size) var(--canvas-grid-size)',
        }}
    />
);

/** Read the current canvas background for PNG export. */
export function getCanvasExportBackground(): string {
    const raw = getComputedStyle(document.documentElement).getPropertyValue('--canvas-bg').trim();
    return raw ? `hsl(${raw})` : '#f8fafc';
}
